<div class="billing-repairer">
    <app-header
        [title]="'support.faturamento-oficinas.header.titulo' | translate"
        [hasBackButton]="false"
        [hasSearchButton]="false"
        [searchInput]="filter"
        [searchPlaceholder]="'support.faturamento-oficinas.header.filtro' | translate"
        (onSearch)="onSearch($event)"
    >
        @if (billingRepairerLastExecution) {
            <div class="general-last-billing">
                <b>{{ 'support.faturamento-oficinas.header.infos.last-billing.title' | translate }}</b>
                {{ billingRepairerLastExecution | date: 'dd/MM/yyyy' }}
                <small>{{ billingRepairerLastExecution | date: 'HH:mm:ss' }}</small>
            </div>
        }
        @if (billingRepairerTotalQuantity) {
            <div class="general-status">
                <b>{{ 'support.faturamento-oficinas.header.infos.status.title' | translate }}</b>
                <span>{{ 'support.faturamento-oficinas.header.infos.status.successes' | translate: { successes: billingRepairerSuccessQuantity, total: billingRepairerTotalQuantity } }}</span>
                <small>{{ 'support.faturamento-oficinas.header.infos.status.errors' | translate: { errors: billingRepairerErrorQuantity } }}</small>
            </div>
        }
        <button customButton styleType="primary" [isLoading]="false" label="support.faturamento-oficinas.header.buttons.atualizar" (click)="loadScreen()" [outline]="true" iconName="refresh-cw" ></button>
        <button customButton styleType="primary" [isLoading]="false" label="support.faturamento-oficinas.header.buttons.faturar.title"   (click)="executePendingBilling()"></button>
    </app-header>
    <div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
        <div class="corpo-pagina">
            <div class="card card-default">
                <app-support-gridview [config]="config" [templates]="templatesArray" (onAction)="executeSelectedBilling($event.item)" [hasLineClick]="true" (onLineClick)="holdingCashbackInfoModal.open($event)"></app-support-gridview>

                <ng-template #lastBillingTemplate let-item>
                    <div class="last-billing-group">
                        @if (item.lastBilling != null) {
                            {{ item.lastBilling | date: 'dd/MM/yyyy' }}
                            <small>{{ item.lastBilling | date: 'HH:mm:ss' }}</small>
                        } @else {
                            -
                        }
                    </div>
                </ng-template>

                <ng-template #statusTemplate let-item>
                    <div class="pill-label" [ngClass]="item.statusClass" [tooltip]="item.errorMessage">
                        {{item.statusDescription}}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<app-billing-repairer-detail #templateBillingRepairerDetail></app-billing-repairer-detail>
